// import { UserDataT } from "@/types/auth";
import { create } from "zustand";
import Axios from "../lib/Axios";

const useSkillGroupStore = create((set) => ({
  groupSkill: [],
  groupSkillSelectCompatiable: [],
  fetchSkillGroup: async () => {
    try {
      const result = await Axios.post("/cms/cms-get/skill-group-name");
      const data = result?.data?.result?.results?.map((item) => {
        return { label: item.groupName, value: item.groupId, ...item };
      });
      set((state) => ({
        groupSkill: result?.data?.result?.results,
        groupSkillSelectCompatiable: data,
      }));
    } catch (error) {}
  },
}));

export default useSkillGroupStore;
